import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Observable, Subscription } from 'rxjs';
import { Document } from '../shared/models/document.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentService } from '../shared/services/document.service';
import { Filter } from '../shared/models/filter.model';
import { RoleSendService } from '../shared/services/role-send.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.sass']
})
export class DocumentsComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;

  addOrEditBool: Boolean = true;
  documentArray: Observable<Document[]>;
  documentId: Number;
  filter: Filter = new Filter({ Top: null, Page: null, Sort: {}, Filter: {} });

  roleService: Subscription;
  roleType: String;

  documentForm = new FormGroup({
    webName: new FormControl('', [Validators.required]),
    fileName: new FormControl('', [Validators.required])
  })

  filterForm = new FormGroup({
    webName: new FormControl('', [])
  })

  constructor(private modalService: NgbModal, private documentService: DocumentService, private roleSendService: RoleSendService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
  }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.documentService.gridView(this.filter)
      .subscribe(
        x => {
          console.log(x)
        },
        e => {
          console.log(e)
        }
      )
    this.documentArray = this.documentService.gridView(this.filter);
  }

  openAddDocumentModal(modal) {
    this.documentForm.reset();
    this.addOrEditBool = true;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  addDocument() {
    let document = new Document({ Caption: this.documentForm.value.webName, Filename: this.documentForm.value.fileName })
    this.documentService.createDocument(document)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openEditDocumentModal(modal, id) {
    this.addOrEditBool = false;
    this.documentService.getOne(id)
      .then(
        (x: { id: Number, caption: String, filename: String }) => {
          this.documentId = id;
          this.documentForm.get('webName').setValue(x.caption);
          this.documentForm.get('fileName').setValue(x.filename);
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
        }
      )
  }
  editDocument() {
    let document = new Document({ Id: this.documentId, Caption: this.documentForm.value.webName, Filename: this.documentForm.value.fileName })
    this.documentService.editDocument(document)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openDeleteDocumentModal(modal, id) {
    this.documentId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  deleteDocument() {
    this.documentService.deleteDocument([this.documentId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  clearFilters() {
    this.filterForm.reset({ webName: '' })
    this.getAll();
  }

}
